// src/components/Logout/Logout.jsx
// 🔧 created by ChatGPT on 2025-10-18 – standard logout button used in Header/ProfileMenu
// 🔧 fixed by Auto on 2025-01-27 – fixed logout method and added goodbye page navigation

import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";

const Logout = () => {
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/goodbye", { replace: true });
  };

  return (
    <button
      onClick={handleLogout}
      style={{
        background: "transparent",
        border: "none",
        color: "#e11d48",
        fontWeight: 500,
        cursor: "pointer",
        padding: "8px 12px",
      }}
      title="Sign out"
    >
      Logout
    </button>
  );
};

export default Logout;
